import { CheckOutlined, CloseOutlined, LoadingOutlined } from '@ant-design/icons';
import { faHourglass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from './HelpersStyles.module.scss';

export const inviteStatusIcons = [
  <FontAwesomeIcon className={classes.glassWaiting} icon={faHourglass} />,
  <CheckOutlined className={classes.pendingInvite_accept} />,
  <CloseOutlined className={classes.pendingInvite_decline} />,
  <LoadingOutlined />,
];


 